import { Button, Input, Select, SelectItem, Textarea } from '@nextui-org/react'
import { useState } from 'react'
const legalForms = ['GmbH', 'AG', 'Einzelunternehmen', 'Limited', 'LLC', 'Corporation', 'Sole Proprietorship', 'General Partnership', 'Other']

export default function CompanyInfo({ formData, handleChange }: any) {
  const isOtherEnabled = legalForms.indexOf(formData?.legalForm) === -1 || formData?.legalForm === 'Other'
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row gap-4">
        <Input
          isRequired
          label="Company Legal Name"
          variant="bordered"
          placeholder="Enter full legal name"
          description="Full legal entity name with suffix and HQ contact data."
          value={formData?.legalName}
          onChange={(e) => handleChange?.('legalName', e.target.value)}
        />
        <Select
          isRequired
          label="Legal Form"
          variant="bordered"
          description="Select the legal structure of the company."
          onChange={(e) => handleChange?.('legalForm', e.target.value)}
          selectedKeys={[isOtherEnabled ? 'Other' : formData?.legalForm]}
        >
          {legalForms.map((form) => (
            <SelectItem key={form} value={form}>
              {form}
            </SelectItem>
          ))}
        </Select>
      </div>
      {
        isOtherEnabled &&
        <>
          <div >
            <Input
              label="Legal Form"
              variant="bordered"
              placeholder="Enter The legal form"
              value={formData?.legalForm === 'Other' ? '' : formData?.legalForm}
              onChange={(e) => handleChange?.('legalForm', e.target.value)}
            />
          </div>
        </>
      }
      <div className="flex flex-row gap-4">
        <Input
          isRequired
          variant="bordered"
          label="Registration Number and Registry"
          placeholder="e.g. HRB-123456 Amtsgericht München"
          value={formData?.registrationNumber}
          onChange={(e) => handleChange?.('registrationNumber', e.target.value)}
        />
        <Input
          isRequired
          label="Year of Establishment"
          placeholder="e.g. 2005"
          variant="bordered"
          type="number"
          value={formData?.yearOfEstablishment}
          onChange={(e) => handleChange?.('yearOfEstablishment', parseInt(e.target.value))}
        />
        <Input
          isRequired
          label="Company Size (FTE Employees)"
          placeholder="e.g. 100"
          type="number"
          variant="bordered"
          value={formData?.companySize}
          onChange={(e) => handleChange?.('companySize', e.target.value)}
        />
      </div>
      <Textarea
        isRequired
        label="Office Locations"
        variant="bordered"
        placeholder="List cities and countries"
        value={formData?.officeLocation}
        onChange={(e) => handleChange?.('officeLocation', e.target.value)}
      />
      <Textarea
        isRequired
        label="Primary Contact Person for Tenders"
        variant="bordered"
        placeholder="Name, role, phone, email"
        value={formData?.primaryContact}
        onChange={(e) => handleChange?.('primaryContact', e.target.value)}
      />
    </div>
  )
}
